module.exports = __webpack_public_path__ + "img/centered-logo-nav-cjdr.6347bb3b.png";